import { render } from "./CaricamentoPun.vue?vue&type=template&id=80637400&scoped=true"
import script from "./CaricamentoPun.vue?vue&type=script&lang=js"
export * from "./CaricamentoPun.vue?vue&type=script&lang=js"

import "./CaricamentoPun.vue?vue&type=style&index=0&id=80637400&scoped=true&lang=css"

import exportComponent from "/Users/giancotsu/Desktop/ASK/ask_file/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80637400"]])

export default __exports__